export default __webpack_public_path__ + "static/media/springwood_brush-webfont.a5adae47.woff";